import {
  encode as encodeEntities,
  decode as decodeEntities,
} from 'html-entities';

/**
 * Decode HTML entities.
 *
 * @param string String with encoded HTML entities.
 *
 * @return string String with HTML entities decoded.
 */
export const decode = (string: string) =>
  // constructor is empty, so no need to memoize.
  decodeEntities(string, { level: 'html5' });

/**
 * Encode HTML entities.
 *
 * @param string String with decoded HTMl entities.
 *
 * @return string String with HTML entities encoded.
 */
export const encode = (string: string) =>
  // constructor is empty, so no need to memoize.
  encodeEntities(string, { level: 'html5' });

/**
 * Replace old cdn assets. with new /assets.
 *
 * @param string Blob or single image src.
 *
 * @return string String with domain replaced.
 */
export const cdnifyImagesInString = (string: string) =>
  typeof string === 'string'
    ? string
        .replace(/assets.nerdwallet.com/g, 'www.nerdwallet.com/assets')
        .replace(/cdn.nerdwallet.com/g, 'www.nerdwallet.com/cdn')
    : string;
